import React from 'react';
import _ResponsiveProductGrid from 'src/components/Modules/ResponsiveProductGrid';

import ContentGroupHOC from '../HOC';
import { compose } from 'redux';

import { errKeys } from 'src/constrains/DraggableModules/tools';
import { get } from 'lodash';
import { ContentModuleGroupPreloadingContext } from 'src/constrains/DraggableModules/PreloadComponent/SubscriptionPreloading';

const ResponsiveProductGrid = (props) => {
  const {
    staticData,
    dynamicData,
    handleOnItemDelete,
    handleItemOnSort,
    handleOnStaticsChange,
    linkSet,
    specificError,
    droppableId,
    handleOnReselect,
    extraProps,
  } = props || {};
  const { breakpoint } = extraProps || {};
  //console.log('specificError', specificError);
  const productToShowError =
    get(specificError, errKeys.ResponsiveProductGrid.productToShow) || [];
  const productToShowMismatchError =
    get(specificError, errKeys.ResponsiveProductGrid.productToShowMismatch) ||
    [];

  const { animations, hoverAnimations, buttons } = React.useContext(
    ContentModuleGroupPreloadingContext,
  );
  //console.log('specificError', specificError);
  //console.log('props', props);
  //console.log('handleOnReselect', handleOnReselect);

  return (
    <_ResponsiveProductGrid
      breakpoint={breakpoint}
      specificError={{ productToShowError, productToShowMismatchError }}
      staticData={staticData}
      products={dynamicData}
      onItemDelete={handleOnItemDelete}
      onItemReselect={handleOnReselect}
      onItemSort={handleItemOnSort}
      onStaticChange={handleOnStaticsChange}
      linkSet={linkSet}
      droppableId={droppableId}
      animations={animations}
      hoverAnimations={hoverAnimations}
      buttons={buttons}
      // onItemReselect={handleOnCarouselItemReselect}
    />
  );
};
export default compose(ContentGroupHOC)(ResponsiveProductGrid);
